import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AppTitleService } from '../../services/app-title.service';
import { AuthService } from '../../services/auth.service';
import { TokenData } from '../../models/User';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
@Component({
  selector: 'app-administracion',
  imports: [
    MatButtonModule, MatDividerModule, MatIconModule,
    RouterLink, RouterLinkActive,
    RouterOutlet, MatSidenavModule,
    MatListModule
],
  templateUrl: './administracion.component.html',
  styleUrl: './administracion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministracionComponent {
  tokenData: TokenData | null
  hasAdminRole = false
  constructor(
    authService: AuthService
  ) {
    inject(AppTitleService).setTitle("Administraci\xf3n");
    this.tokenData = authService.getTokenData()
    if (this.tokenData) {
      if (this.tokenData.roles.includes("sgd_admin")) {
        this.hasAdminRole = true

      }
    }
  }
}
